var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons",
    clipPath: "url(#clip0_12_13086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6676 0.947266H1.32891C0.594141 0.947266 0 1.52734 0 2.24453V17.6465C0 18.3637 0.594141 18.9473 1.32891 18.9473H16.6676C17.4023 18.9473 18 18.3637 18 17.65V2.24453C18 1.52734 17.4023 0.947266 16.6676 0.947266ZM5.34023 16.2859H2.66836V7.69375H5.34023V16.2859ZM4.0043 6.52305C3.14648 6.52305 2.45391 5.83047 2.45391 4.97617C2.45391 4.12187 3.14648 3.4293 4.0043 3.4293C4.85859 3.4293 5.55117 4.12187 5.55117 4.97617C5.55117 5.82695 4.85859 6.52305 4.0043 6.52305ZM15.3387 16.2859H12.6703V12.1094C12.6703 11.1145 12.6527 9.83125 11.2816 9.83125C9.89297 9.83125 9.68203 10.9176 9.68203 12.0391V16.2859H7.01719V7.69375H9.57656V8.86797H9.61172C9.9668 8.19297 10.8387 7.4793 12.1359 7.4793C14.8395 7.4793 15.3387 9.2582 15.3387 11.5715V16.2859Z",
    fill: "#DD5800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_13086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.947266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatSocialLinkedin);
export default __webpack_public_path__ + "static/media/sat_social_linkedin.75d1e441ffb06de743ab0da22bb48b7b.svg";
export { ForwardRef as ReactComponent };